export default __webpack_public_path__ + "static/Cervejas-crystal-f0de8d0c758f9e6f74b6923bd919d6e2.jpg";